export enum PermissionTypeEnum {
    SYSTEM = 'system',
    EXTERNAL = 'external'
}